<template>
  <div>
    <populate-form
      formTitle="請款單管理"
      fkey="pm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="storeServiceChanged"
    ></populate-form>
    <b-tabs class="mt-1" @input="changeTab" v-model="CurrentTabIndex">
      <b-tab title="未請款">
        <b-form-checkbox class="float-left ml-3 mt-3" v-model="checkAll" @change="checkAllUpdate" :disabled="$bus.getRole()==='admin'">全選/全不選</b-form-checkbox>
        <span class="float-left ml-2 mt-3" v-b-tooltip.hover title="已勾選/已載入(數量多時需往下scroll載入更多)/總數(當前條件的可選票券總數)">({{totalSelected}}/{{ticketList.length}}/{{ticketTotal}})</span>
        <b-button class="float-right mr-2" :disabled="$bus.getRole()==='admin'" @click="createApplyFrom">建立請款單</b-button>
        <b-button class="float-right mr-2" :disabled="$bus.getRole()!=='admin'" @click="createPapperApplyFrom">手動建立紙本請款單</b-button>
        <div class="select-tickets" ref="wrapper" @scroll="handleScroll">
          <loading
            :show="tabClicking&&$bus.getRole()!=='admin'"
            label="讀取更新數據中">
          </loading>
          <b-table
            ref="scrollarea"
            v-show="!tabClicking||$bus.getRole()==='admin'"
            hover
            show-empty
            stacked="sm"
            @row-clicked="selectionChange"
            :fields="ticketFields" :items="ticketList"
            @scrolldownend="getTicketList(true)"
          >
            <template slot="empty">
              進行載入...當前條件無資料...
            </template>
            <template v-slot:cell(actions)="row">
              <b-form-checkbox class="mx-auto" v-show="$bus.getRole()!=='admin'" v-model="row.item.checked" @change="updateCheckAll"/>
            </template>
          </b-table>
        </div>
      </b-tab>
      <b-tab title="請款中">
        <b-row v-if="$bus.getRole()==='admin'">
          <b-form-checkbox class="col-2" v-model="checkAll2" @change="checkAllUpdate2" >全選/全不選</b-form-checkbox>
          <span class="col-3"></span>
          <b-button class="col-2 mr-4" @click="showUpload">上傳放款回兌明細</b-button>
          <b-button class="col-2 mr-2" @click="downloadSelectedXls">勾選批次下載</b-button>
          <b-button class="col-2 ml-4" @click="updateApplyStateDownloadedMulti">勾選批次確認</b-button>
        </b-row> 
        <div class="view-forms">
          <loading
            :show="tabClicking"
            label="讀取更新數據中">
          </loading>
          <b-table
            :fields="applyFormFields" :items="formList"
            show-empty
            v-show="!tabClicking"
          >
            <template slot="empty">
              進行載入...當前條件無資料...
            </template>
            <template v-slot:cell(check)="row">
              <b-form-checkbox v-model="row.item.checked" @change="updateCheckAll2"></b-form-checkbox>
            </template>
            <template v-slot:cell(request_amount)="row">
              {{row.item.request_amount}}<span v-show="row.item.remit_amount_final!=row.item.request_amount">(調整為{{row.item.remit_amount_final}})</span>
            </template>
            <template v-slot:cell(status)="row">
              {{($bus.getRole()!=='admin'&&row.item.status==='已下載')?'處理中':row.item.status}}
            </template>
            <template v-slot:cell(apply_name)="row">
              {{row.item.apply_by==='供應商'?row.item.merchant_name:(row.item.apply_by==='店家'?('(店)'+row.item.store_name):('(紙)'+row.item.merchant_name))}}
            </template>
            <template v-slot:cell(actions)="row">
              <!--後台部分,業務有送審與退審,會計有送審和退審,兩者都有備註-->
              <b-button v-if="$bus.getRole()==='admin'&&row.item.status==='申請中'" @click="showFormDetail(row.item)">業務確認</b-button>
              <b-button v-if="$bus.getRole()==='admin'&&row.item.status==='處理中'" @click="showFormDetail(row.item)">財務確認</b-button>
              <b-button v-if="$bus.getRole()==='admin'&&row.item.status==='已下載'" @click="showFormDetail(row.item)">確認放款</b-button>
              <!--業務的操作都可以下載明細-->
              <b-button v-show="($bus.getRole()==='admin'||((['spalogin','merchant'].includes($bus.getRole()))&&$bus.session))" @click="downloadXls(row.item)" class="mr-1"><font-awesome-icon :icon="['fas','download']" />明細Xls</b-button>

              <!--商家部分,總管理有刪單與查看明細(popup不顯示太詳細資料)-->
              <b-button v-if="$bus.getRole()!=='admin'" @click="showFormDetail(row.item)">查看/操作</b-button>
            </template>
          </b-table>
        </div>
      </b-tab>
      <b-tab title="已放款">
        <b-row v-if="$bus.getRole()==='admin'">
          <b-form-checkbox class="col-2" v-model="checkAll2" @change="checkAllUpdate2" >全選/全不選</b-form-checkbox>
          <span class="col-5"></span>
          <b-button class="col-2 mr-2" @click="downloadSelectedXls">勾選批次下載</b-button>
          <b-button class="col-2 ml-4" @click="updateApplyStateDownloadedMulti">勾選批次確認</b-button>
        </b-row> 
        <div class="view-forms">
          <loading
            :show="tabClicking"
            label="讀取更新數據中">
          </loading>
          <b-table
            :fields="applyFormFields" :items="formList"
            show-empty
            v-show="!tabClicking"
          >
            <template slot="empty">
              進行載入...當前條件無資料...
            </template>
            <template v-slot:cell(check)="row">
              <b-form-checkbox v-model="row.item.checked" @change="updateCheckAll2"></b-form-checkbox>
            </template>
            <template v-slot:cell(request_amount)="row">
              {{row.item.request_amount}}<span v-show="row.item.remit_amount_final!=row.item.request_amount">(調整為{{row.item.remit_amount_final}})</span>
            </template>
            <template v-slot:cell(apply_name)="row">
              {{row.item.apply_by==='供應商'?row.item.merchant_name:(row.item.apply_by==='店家'?('(店)'+row.item.store_name):('(紙)'+row.item.merchant_name))}}
            </template>
            <template v-slot:cell(actions)="row">
              <b-button v-if="$bus.getRole()==='admin'&&row.item.status==='已放款'" @click="showFormDetail(row.item)">查看表單</b-button>
              <!--後台部分,除下載csv無其他功能-->
              <b-button v-show="($bus.getRole()==='admin'||((['spalogin','merchant'].includes($bus.getRole()))&&$bus.session))" @click="downloadXls(row.item)" class="mr-1"><font-awesome-icon :icon="['fas','download']" />明細Xls</b-button>
              <!--商家部分,總管理有查看明細(popup不顯示太詳細資料)-->
              <b-button v-if="$bus.getRole()!=='admin'" @click="showFormDetail(row.item)">查看/操作</b-button>
            </template>
          </b-table>
        </div>
      </b-tab>
      <b-tab title="刪單/退審">
        <div class="view-forms">
          <loading
            :show="tabClicking"
            label="讀取更新數據中">
          </loading>
          <b-table
            :fields="applyFormFields" :items="formList"
            show-empty
            v-show="!tabClicking"
          >
            <template slot="empty">
              進行載入...當前條件無資料...
            </template>
            <template v-slot:cell(apply_name)="row">
              {{row.item.apply_by==='供應商'?row.item.merchant_name:(row.item.apply_by==='店家'?('(店)'+row.item.store_name):('(紙)'+row.item.merchant_name))}}
            </template>
            <template v-slot:cell(actions)="row">
              <b-button v-if="$bus.getRole()==='admin'&& ['已取消','已拒絕'].includes(row.item.status)" @click="showFormDetail(row.item)">查看表單</b-button>
              <b-button v-show="$bus.getRole()==='admin'" @click="downloadXls(row.item)" class="ml-1">下載明細excel</b-button>
              <!--後台部分,除下載csv無其他功能-->
              <!--商家部分,總管理有查看明細(popup不顯示太詳細資料)-->
              <b-button v-if="$bus.getRole()!=='admin'" @click="showFormDetail(row.item)">查看/操作</b-button>
            </template>
          </b-table>
        </div>
      </b-tab>
    </b-tabs>
    <b-modal
      id="createPaperPaymentFormModal"
      ref="createFormModal1"
      v-model="showPaperCreateForm"
      size="lg"
      centered
      :static="true"
      ok-title="建立"
      v-on:ok="pressOkCreatePaperForm"
      cancel-title="清除"
      v-on:cancel="clearCreatePaperForm"
    >
      <populate-form
        formTitle="建立紙本請款單"
        fkey="cf02"
        ref="createForm1"
        :parentVue="this"
        populateOptionVar="createPFOptions1"
        formDataObjVar="createPFData1"
        @customValueChanged="storeServiceChanged_1"
      ></populate-form>
      <PaperApplyForm ref="paperapplyform" :parentVue="this">
      </PaperApplyForm>
    </b-modal>
    <b-modal
      id="createPaymentFormModal"
      ref="createFormModal"
      v-model="showCreateForm"
      size="lg"
      centered
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="建立請款單"
        fkey="cf01"
        ref="createForm"
        :parentVue="this"
        populateOptionVar="createPFOptions"
        formDataObjVar="createPFData"
      ></populate-form>
      <div
        class="detail-summary"
      >
        <!--每一筆itemDetails都要有_showDetails這個屬性(預設縮起值給false),toggtleDetails這個動作才有效果,才能展開/縮起該列詳細-->
        <b-table
          :items="createPFData.itemDetails"
          :fields="summaryFields"
          :bordered="true"
        >
          <template v-slot:cell(actions)="row">
            <b-button @click="row.toggleDetails">{{row.item._showDetails?'隱藏明細':'展開明細'}}</b-button>
          </template>
          <template v-slot:row-details="row">
            <b-list-group>
              <b-list-group-item
                style="text-align:left"
                v-for="item in row.item.tickets" :key="item.ticket_no"
              >票號:{{item.ticket_no}}-時間:{{item.ticket_scan_time}}-分店:{{item.merchant_store_name}}-購票者:{{item.buyer_name}}</b-list-group-item>
            </b-list-group>
          </template>
        </b-table>
      </div>
    </b-modal>
    <b-modal
      id="operatePaymentFormModal"
      ref="operateFormModal"
      v-model="showOperateForm"
      size="lg"
      centered
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="檢視/操作請款單"
        fkey="of01"
        ref="operateForm"
        :parentVue="this"
        populateOptionVar="operatePFOptions"
        formDataObjVar="operatePFData"
      ></populate-form>
      <div
        class="detail-summary"
      >
        <b-table
          :items="operatePFData.itemDetails"
          :fields="summaryFieldsForView"
          :bordered="true"
        >
          <template v-slot:cell(actions)="row">
            <b-button @click="row.toggleDetails">{{row.item._showDetails?'隱藏明細':'展開明細'}}</b-button>
          </template>
          <template v-slot:row-details="row">
            <b-list-group>
              <b-list-group-item
                v-for="item in row.item.tickets" :key="item.ticket_no"
              >票號:{{item.ticket_no}}-時間:{{item.ticket_scan_time}}-分店:{{item.merchant_store_name}}-購票者:{{item.buyer_name}}</b-list-group-item>
            </b-list-group>
          </template>
        </b-table>
      </div>
    </b-modal>
    <b-modal
      id="uploadUpdPaidModal"
      ref="uploadUpdPaidModal"
      title="以回兌確認excel上傳更新請款單已放款"
      v-model="showOUploadForm"
      size="lg"
      centered
      hide-footer
      :static="true"
    >
      <div>
        (請款單明細的票券全部透過上傳回兌確認後自動更新請款單為已放款,可分多次上傳)
        <br>
        <b-form-file v-model="uploadFile" placeholder="上傳回兌明細格式excel" @change="uploadDone=false"></b-form-file>
        <b-button v-show="!uploadDone" @click="doUpload" >上傳</b-button>
        <div v-show="uploadDone">
          處理完成<b-button @click="showOUploadForm=false">關閉</b-button>
          <ul>
            <li>本次處理票券數：{{uploaded_status.upload_ticket_count}}</li>
            <li title="未拋至核銷平台的票,應該是紙本票,與線上電子票無關">票券核銷未拋數：{{uploaded_status.skipped_ticket_count}}</li>
            <li title="紙本票不在請款單範圍請跳過">紙本票數：{{uploaded_status.ticket_paper_count}}</li>
            <li title="暫時不會有,PI設定由核銷店家自行請款的放款判斷未確認,目前遇到不處理">店家請款未處理數：{{uploaded_status.ticket_store_apply_skipped}}</li>
            <li title="之前已上傳回兌完成">重複已上傳數：{{uploaded_status.ticket_already_uploaded}}</li>
            <li title="供應商未請款即回兌異常">票券未請款數(異常)：{{uploaded_status.not_applied_count}}</li>
            <li title="數據庫異常請通知IT">票券更新失敗數(異常)：{{uploaded_status.ticket_db_fail_count}}</li>
            <li></li>
            <li>回兌票關聯請款單數：{{uploaded_status.process_pf_count}}</li>
            <li title="原本就已放款不用更新">其中零成本請款單數：{{uploaded_status.zero_cost_pfs}}</li>
            <li title="經本次上傳更新為已放款的請款單">更新已放款請款單數：{{uploaded_status.close_pf_count}}</li>
            <li title="不為零成本與成功更新已放款的資訊">異常請款單參考資訊：{{uploaded_status.abnormal_pfs}}</li>
          </ul>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import saveAs from 'file-saver'
import loading from 'vue-full-loading'
import PaperApplyForm from '../Common/PaperApplyForm.vue'

import {
  apiGetMerchantAutoComplete,
  apiGetMerchantById,
  apiUpdatePaymentRequestStatus,
  apiCreatePaperPaymentForm,
  apiUpdatePaymentRequestDownloadedMultiple 
} from '@/api/AdminManage.js'

import { 
  apiDownloadFile
 } from '@/api/Util.js'

import {
  apiGetPaymentRequestFormList,
  apiGetPaymentRequestFormDetail,
  apiUpdatePaymentRequestForm,
  apiCancelPaymentRequestForm,
  apiCreatePaymentRequestForm,
  apiGetPFDetailXls,
  apiGetUsedWaitProcessTickets,
  apiGetTicketStatus,
  apiGetPFDetailXls3
} from '@/api/Merchant.js'

export default {
  name: 'PaymentFormAdminView',
  components: {
    loading,
    PaperApplyForm,
  },
  data: function () {
    return {
      paper_merchant_id: null,
      paper_merchant_invoice_type: 'receipt',
      showPaperCreateForm: false,
      showCreateForm:false,
      showOperateForm:false,
      showOUploadForm:false,
      uploadFile:null,
      uploadDone:false,
      uploaded_status:{},
      operatePFData:{},
      operatePFOptions:[
        {
          'componentType':'span',
          'placeholder':'請款單號',
          'col':3,
        },
        {
          'componentType':'text',
          'akey':'pf',
          'disabled':true,
          'col':4,
        },
        {
          'componentType':'span',
          'col':5,
        },
        {
          'componentType':'span',
          'placeholder':'發票號碼',
          'col':3,
          'hide':(this.$bus.session.invoice_type!=='invoice'&&this.$bus.getRole()!=='admin'),
        },
        {
          'componentType':'text',
          'akey':'invoice_no',
          'placeholder':'此供應商使用收據',
          'col':3,
          'defaultValue':'',
          'disabled':true,
          'hide':(this.$bus.session.invoice_type!=='invoice'&&this.$bus.getRole()!=='admin'),
        },
        {
          'componentType':'span',
          'placeholder':'發票日期',
          'col':3,
          'hide':(this.$bus.session.invoice_type!=='invoice'&&this.$bus.getRole()!=='admin'),
        },
        {
          'componentType':'date-picker',
          'akey':'invoice_date',
          'defaultValue':null,
          'placeholder':'',
          'col':3,
          'disabled':true,
          'hide':(this.$bus.session.invoice_type!=='invoice'&&this.$bus.getRole()!=='admin'),
        },
        {
          'componentType':'span',
          'placeholder':'品名',
          'col':3,
        },
        {
          'componentType':'text',
          'akey':'itemSummary',
          'defaultValue':'服務費',
          'col':3,
          'disabled':true,
        },
        {
          'componentType':'span',
          'col':6
        },
        /*{
          'componentType':'span',
          'placeholder':'數量',
          'col':2,
        },
        {
          'componentType':'span',
          'col':1,
          'placeholder':'1',
        },*/
        {
          'componentType':'span',
          'col':3,
          'placeholder':"總金額",
        },
        {
          'componentType':'number',
          'akey':'total',
          'col':3,
          'disabled':true,
        },
        {
          'componentType':'span',
          'col':3,
          'placeholder':"稅額",
          'hide':(this.$bus.session.invoice_type!=='invoice'),
        },
        {
          'componentType':'number',
          'akey':'totalTax',
          'col':3,
          'disabled':true,
          'hide':(this.$bus.session.invoice_type!=='invoice'),
        },
        {
          'componentType':'span',
          'col':2,
          'placeholder':'備註'
        },
        {
          'componentType':'text',
          'akey':'merchant_remark',
          'col':10,
          'disabled':this.$bus.getRole()==='admin',
          'placeholder':'自行輸入的備註',
        },
        {
          'componentType':'span',
          'col':2,
          'placeholder':'回覆'
        },
        {
          'componentType':'text',
          'akey':'sales_remark',
          'col':10,
          'disabled':this.$bus.getRole()!=='admin',
          'placeholder':this.$bus.getRole()==='admin'?'請輸入給供應商的留言':'空空的沒有留言...'
        },
        {
          componentType:'b-button',
          akey:'btn-merchant-update-remark',
          col:3,
          placeholder:'更新備註',
          hide:this.$bus.getRole()==='admin',
          execCallback:this.updateMerchantRemark
        },
        {
          componentType:'b-button',
          akey:'btn-merchant-cancel-apply',
          col:3,
          placeholder:'刪單',
          hide:this.$bus.getRole()==='admin',
          execCallback:this.cancelApplyForm
        },
        {
          componentType:'span',
          col:6,
          hide:this.$bus.getRole()==='admin'
        },
        {
          componentType:'b-button',
          akey:'btn-sales-update-remark',
          col:3,
          placeholder:'回覆供應商備註',
          hide:this.$bus.getRole()!=='admin',
          execCallback:this.updateSalesRemark
        },
        {
          componentType:'b-button',
          akey:'btn-reject-apply',
          col:2,
          placeholder:'拒絕退回',
          hide:this.$bus.getRole()!=='admin',
          execCallback:this.updateSalesReject
        },
        {
          componentType:'b-button',
          akey:'btn-process-apply',
          col:2,
          placeholder:'確認處理中',
          hide:this.$bus.getRole()!=='admin',
          execCallback:this.updateSalesProcess
        },
        {
          componentType:'b-button',
          akey:'btn-download-apply',
          col:2,
          placeholder:'確認已下載',
          hide:this.$bus.getRole()!=='admin',
          execCallback:this.updateSalesDownloaded
        },
        {
          componentType:'b-button',
          akey:'btn-confirm-paid',
          col:3,
          placeholder:'確認已放款',
          hide:this.$bus.getRole()!=='admin',
          execCallback:this.updateSalesConfirm
        },
      ],
      createPFData:{},
      createPFData1:{
        itemSummary: '服務費'
      },
      // createPFData1:
      // {
      //   'form_summary': "服務費_1_404_404,服務費_2_264_528",
      //   'inside_ids': "230817,230812,230347",
      //   'invoice_date': "2020/12/31",
      //   'invoice_no': "",
      //   'itemDetails': [
      //       {
      //         'cost_price': 404,
      //         'count': 1,
      //         'course_id': "服務費",
      //         'product_id': "PI20190227000004",
      //         'ticket_name': "《北南部》【兩人同行一人免費】120分鐘皇后玫瑰精油+婦宮陶瓷激活SPA",
      //         'tickets': [
      //             {
      //                 'buyer_name': "(不記名)line Coupon",
      //                 'checked': true,
      //                 'cost_price': 404,
      //                 'dual_type': "line",
      //                 'merchant_store_name': "莉筑美容SPA中心",
      //                 'product_id': "PI20190227000004",
      //                 'sale_price': 999,
      //                 'ticket_item_id': 230817,
      //                 'ticket_no': "AA00983357",
      //                 'ticket_project_id': 1516,
      //                 'ticket_project_name': "《北南部》【兩人同行一人免費】120分鐘皇后玫瑰精油+婦宮陶瓷激活SPA",
      //                 'ticket_scan_time': "2019-10-01 14:07:23",                                
      //             },
      //         ],
      //         'totalAmt': 404,
      //         '_showDetails': false,    
      //       },
      //       {
      //         'cost_price': 264,
      //         'count': 2,
      //         'course_id': "服務費",
      //         'product_id': "PI20190920000001",
      //         'ticket_name': "《北部》180分鐘!全身有機乳香精油按摩+美白消水腫激SO懶人曲線",
      //         'tickets': [
      //             {
      //               'buyer_name': "LisaWeng",
      //               'checked': true,
      //               'cost_price': 264,
      //               'dual_type': "electronic",
      //               'merchant_store_name': "名媛店",
      //               'product_id': "PI20190920000001",
      //               'sale_price': 688,
      //               'ticket_item_id': 230812,
      //               'ticket_no': "AA00983353",
      //               'ticket_project_id': 1739,
      //               'ticket_project_name': "《北部》180分鐘!全身有機乳香精油按摩+美白消水腫激SO懶人曲線",
      //               'ticket_scan_time': "2019-09-28 12:58:55",
      //             },
      //             {
      //               'buyer_name': "薛瑛茹",
      //               'checked': true,
      //               'cost_price': 264,
      //               'dual_type': "electronic",
      //               'merchant_store_name': "采宣店",
      //               'product_id': "PI20190920000001",
      //               'sale_price': 688,
      //               'ticket_item_id': 230347,
      //               'ticket_no': "AA00983001",
      //               'ticket_project_id': 1739,
      //               'ticket_project_name': "《北部》180分鐘!全身有機乳香精油按摩+美白消水腫激SO懶人曲線",
      //               'ticket_scan_time': "2019-09-26 10:55:09",
      //             }                
      //         ],
      //         'totalAmt': 528,
      //         '_showDetails': false  
      //       }
      //   ],
      //   'itemSummary': "服務費",
      //   'merchant_remark': "",
      //   'total': 932,
      //   'totalTax': 44,   
      // },
      createPFOptions1: [
        {
          'componentType':'span',
          'placeholder':'供應商',
          'col':2,
          'hide':this.$bus.getRole()!=='admin',
        },
        {
          'componentType':'vue-single-select',
          'optionVar':'Merchants',
          'asyncFetchCB': this.loadMerchantByKeyword,
          'defaultValue':null,
          'akey':'SelectedMerchantItem',
          //'optionLabel':'merchant_name',
          'optionLabel':'merchant_full_name',
          'col':10,
          'placeholder':'指定供應商查看',
          'title':'切換選擇即更新下方顯示,選擇任一供應商後才顯示',
          'hide':this.$bus.getRole()!=='admin',
        },
        {
          'componentType':'span',
          'placeholder':'發票號碼',
          'col':2,
        },
        {
          'componentType':'text',
          'akey':'invoice_no',
          'placeholder':'輸入發票號碼',
          'col':3,
          'defaultValue':'',
        },
        {
          'componentType':'span',
          'placeholder':'發票日期',
          'col':2,
        },
        {
          'componentType':'date-picker',
          'akey':'invoice_date',
          'defaultValue': null,
          'placeholder':'輸入發票日期',
          'col':3,
        },
        {
          'componentType':'span',
          'placeholder':'',
          'col':12,
        },
        {
          'componentType':'span',
          'placeholder':'品名',
          'col':2,
        },
        {
          'componentType':'text',
          'akey':'itemSummary',
          'defaultValue':'服務費',
          'col':3,
        },
        {
          componentType:'span',
          col:6
        },
        {
          'componentType':'span',
          'col':2,
          'placeholder':"總金額",
        },
        {
          'componentType':'number',
          'akey':'total',
          'col':3,
        },
        {
          'componentType':'span',
          'col':2,
          'placeholder':"稅額",
        },
        {
          'componentType':'number',
          'akey':'totalTax',
          'col':3,
        },
        {
          componentType:'span',
          col:2,
        },
        // {
        //   'componentType':'span',
        //   'col':2,
        //   'placeholder':'店家備註'
        // },
        // {
        //   'componentType':'text',
        //   'akey':'merchant_remark',
        //   'col':8,
        //   'placeholder':'自行輸入'
        // },
        // {
        //   componentType:'span',
        //   col:2,
        // },
        // {
        //   'componentType':'span',
        //   'col':2,
        //   'placeholder':'客服回覆'
        // },
        // {
        //   'componentType':'text',
        //   'akey':'support_remark',
        //   'col':8,
        //   'placeholder':'自行輸入'
        // },
          // {
          //   'componentType':'b-button',
          //   'col':2,
          //   'placeholder':'建立',
          //   'execCallback':this.confirmCreateApply,
          //   'waitClick':true,
          // },       
      ],
      createPFOptions:[
        {
          'componentType':'span',
          'placeholder':'發票號碼',
          'col':2,
          'hide':(this.$bus.session.invoice_type!=='invoice'),
        },
        {
          'componentType':'text',
          'akey':'invoice_no',
          'placeholder':'輸入發票號碼',
          'col':3,
          'defaultValue':'',
          'hide':(this.$bus.session.invoice_type!=='invoice'),
        },
        {
          'componentType':'span',
          'placeholder':'發票日期',
          'col':2,
          'hide':(this.$bus.session.invoice_type!=='invoice'),
        },
        {
          'componentType':'date-picker',
          'akey':'invoice_date',
          'defaultValue':null,
          'placeholder':'輸入發票日期',
          'col':3,
          'hide':(this.$bus.session.invoice_type!=='invoice'),
        },
        {
          'componentType':'span',
          'placeholder':'',
          'col':12,
          'hide':(this.$bus.session.invoice_type!=='invoice'),
        },
        {
          'componentType':'span',
          'placeholder':'品名',
          'col':2,
        },
        {
          'componentType':'text',
          'akey':'itemSummary',
          'defaultValue':'服務費',
          'col':3,
          'disabled':true,
        },
        {
          componentType:'span',
          col:6
        },
        {
          'componentType':'span',
          'col':2,
          'placeholder':"總金額",
        },
        {
          'componentType':'number',
          'akey':'total',
          'col':3,
          'disabled':true,
        },
        {
          'componentType':'span',
          'col':2,
          'placeholder':"稅額",
          'hide':(this.$bus.session.invoice_type!=='invoice'),
        },
        {
          'componentType':'number',
          'akey':'totalTax',
          'col':3,
          'disabled':true,
          'hide':(this.$bus.session.invoice_type!=='invoice'),
        },
        {
          componentType:'span',
          col:2,
        },
        {
          'componentType':'span',
          'col':2,
          'placeholder':'備註'
        },
        {
          'componentType':'text',
          'akey':'merchant_remark',
          'col':8,
          'placeholder':'自行輸入的備註'
        },
        {
          'componentType':'b-button',
          'col':2,
          'placeholder':'建立',
          'execCallback':this.confirmCreateApply,
          'waitClick':true,
        },
      ],
      checkAll:false,
      checkAll2:false,
      //當綁了v-model時,若值為0一開始就會觸發程式導致程式錯誤＝＝
      CurrentTabIndex:-1,//0:searchTicket/1:processFormList/2:doneFormList/3:cancelFormList
      merchantOptionIndex:1,
      storeOptionIndex:2,
      productOptionIndex:3,
      formTypeOptionIndex:4,
      createFromOptionIndex:5,
      createToOptionIndex:6,
      SelectedMerchantId:0,
      CachedMerchant: {},
      filterInitialized: false,
      filterData: {
        SelectedMerchantItem: null,
        selectedStore: null,
        selectedServiceItem: null,
      },
      // 別寫這 之後搬到created或mounted裡,可以處理時間差載入傳下去的資料
      filterOptions: [
        {
          'componentType':'span',
          'placeholder':'供應商',
          'col':2,
          'hide':this.$bus.getRole()!=='admin',
        },
        {
          'componentType':'vue-single-select',
          'optionVar':'Merchants',
          'asyncFetchCB': this.loadMerchantByKeyword,
          'defaultValue':null,
          'akey':'SelectedMerchantItem',
          //'optionLabel':'merchant_name',
          'optionLabel':'merchant_full_name',
          'col':10,
          'placeholder':'指定供應商查看',
          'title':'切換選擇即更新下方顯示,選擇任一供應商後才顯示',
          'hide':this.$bus.getRole()!=='admin',
        },
        {
          'componentType':'b-form-select',
          'optionVar':'storeList',
          'defaultValue':null,
          'akey':'selectedStore',
          'optionLabel':'store_name',
          'col':6,
          'placeholder':(this.$bus.getRole()==='admin'?'全部分店':''),
          'hide':(this.$bus.getRole()!=='admin' && !this.$bus.session.is_super_manage),
        },
        {
          'componentType':'b-form-select',
          'optionVar':'TicketServiceList',
          'defaultValue':null,
          'akey':'selectedServiceItem',
          'optionLabel':'service_name',
          'col':6,
          'placeholder':(this.$bus.getRole()==='admin'?'全部課程':''),
          'hide':false,
        },
        {
          'componentType':'b-form-select',
          'defaultValue':'',
          'akey':'statusType',
          'col':4,
          'placeholder':(this.$bus.getRole()==='admin'?'狀態篩選':''),
          'dataOptions':[{text:'全部',value:''},{text:'申請中',value:'requesting'}],
          'hide':true,
        },
        {
          componentType:'date-picker',
          col:4,
          akey:'createFromDate',
          placeholder:'篩選請款單建立日期起',
          hide:true
        },
        {
          componentType:'date-picker',
          col:4,
          akey:'createToDate',
          placeholder:'篩選請款單建立日期迄',
          hide:true
        }
      ],
      showDate: new Date(),
      applyFormFields:[
        {
          key: 'ns_vd_id',
          label: 'NS Vendor ID',
          sortable: true,
        },
        {
          key: 'request_time',
          label: '請款日期',
          sortable: true,
        },
        {
          key: 'request_amount',
          label: '金額',
          sortable: true,
        },
        {
          key: 'tickets_inside',
          label: '張數',
          sortable: false
        },
        {
          key: 'pf',
          label: '請款單號',
          sortable: true
        },
        {
          key: 'invoice_no',
          label: '發票號碼',
          sortable: true,
        },
        {
          key: 'status',
          label: '處理進度',
          sortable: false
        },
        {
          key: 'sales_remark',
          label: 'S99業務回覆',
          sortable: false
        },        
        {
          key: 'merchant_remark',
          label: '店家備註',
          sortable: false
        },
        {
          key: 'actions',
          label: '操作',
          sortable: false
        },
      ],
      summaryFields:[
        {
          key:'ticket_name',
          label:'(以下是各課程小計)'
        },
        {
          key:'course_id',
          label:'簡稱'
        },
        {
          key:'cost_price',
          label:'單價'
        },
        {
          key:'count',
          label:'張數'
        },
        {
          key:'totalAmt',
          label:'小計(含稅)'
        },
        {
          key:'actions',
          label:'',
        },
      ],
      summaryFieldsForView:[
        {
          key:'ticket_name',
          label:'(以下是各課程小計)'
        },
        {
          key:'course_id',
          label:'簡稱'
        },
        {
          key:'cost_price',
          label:'單價'
        },
        {
          key:'count',
          label:'張數'
        },
        {
          key:'totalAmt',
          label:'小計(含稅)'
        },
        {
          key:'actions',
          label:'',
        },
      ],
      formList:[],
      hasMore:true,
      isLoading:false,
      ticketTotal:0,
      ticketList:[],
      ticketFields:[
        {
          key: 'actions',
          label: '選取'
        },
        {
          key: 'buyer_name',
          label: '購票者'
        },
        {
          key: 'ticket_scan_time',
          label: '核銷時間'
        },
        {
          key: 'merchant_store_name',
          label: '分店'
        },
        {
          key: 'product_id',
          label: '產品id'
        },
        {
          key: 'ticket_project_name',
          label: '課程'
        },
        {
          key: 'ticket_no',
          label: '票號'
        },
        {
          key: 'cost_price',
          label: '金額'
        },
        
        
      ],
      ticketPageNumber:1,
      ticketItemsPerPage:50,
      Merchants: [],
      storeList: [],
      selectedStore: {},
      TicketServiceList: [],
      selectedServiceItem: {},
      tabClicking:false,
      merchant_lists: [],
    }
  },
  props: [

  ],
  methods: {
    showUpload() {
      //重新初始化
      this.uploadDone = false
      this.uploadFile = null
      this.uploaded_status = {}
      //顯示popup就好
      this.showOUploadForm = true
    },
    doUpload() {
      //檢查檔案有上傳
      if (!this.uploadFile) {
        this.$bus.fnShowInfo("請先選擇上傳檔案")
        return
      }
      this.uploaded_status = {}
      //有檔案就呼叫api
      let Param = {
        module:'customer_service',
        method:'uploadPaidTicketFile',
        paidXlsFile:this.uploadFile
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok == 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        vm.uploaded_status = data.data
        vm.uploadDone = true
        if (vm.uploaded_status.close_pf_count > 0) {
          vm.getFormList()
        }
      }, this)

    },
    updateSalesRemark() {
      this.updateApplyState()
    },
    updateSalesProcess() {
      this.updateApplyState('processing')
    },
    updateSalesDownloaded() {
      this.updateApplyState('downloaded')
    },
    updateSalesConfirm() {
      this.updateApplyState('paid')
    },
    updateSalesReject() {
      this.updateApplyState('rejected')
    },
    updateApplyState(status = '') {
      //if (!this.operatePFData || !this.operatePFData.originalStatus) {
      //  return
      //}
      // 更新請款狀態(拒絕/處理中/已放款的狀態更新),未傳時則只更新管理者備註(保持原狀態)
      if (status === '') {
        status = this.operatePFData.originalStatus
      }
      let Param = {
        module:'admin_manage',
        method:'updatePaymentRequestStatus',
        form_id:this.operatePFData.payment_request_form_id,
        form_status:status,
        remark:this.operatePFData.sales_remark
      }

      let vm = this
      apiUpdatePaymentRequestStatus(Param).then(function(resp){
        let data = resp.data
        vm.$bus.fnShowInfo('更新完成')
        vm.getFormList()
        vm.showOperateForm = false
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
          return
        }
      })

      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //     return
      //   }
      //   vm.$bus.fnShowInfo('更新完成')
      //   vm.getFormList()
      //   vm.showOperateForm = false
      // }, this)
    },
    updateApplyStateDownloadedMulti() {
      
      // 只有在請款中的處理中與已付款的0成本表單
      let form_ids = []
      for (let i=0;i<this.formList.length;i++) {
        if (this.formList[i].checked) {
          form_ids.push(this.formList[i].payment_request_form_id)
        }
      }
      if (form_ids.length === 0) {
        this.$bus.fnShowInfo('沒有勾選的表單')
        return
      }
      let vm = this
      this.$bus.fnShowConfirm('確認要更新這'+form_ids.length+'張請款單為已下載?', () => {
        
        console.log('axios',this.$axios)

        let Param = {
          module:'admin_manage',
          method:'updatePaymentRequestDownloadedMultiple',
          form_ids:form_ids,
          form_status:'downloaded',
        }
        apiUpdatePaymentRequestDownloadedMultiple(Param).then(function(resp){ 
          let data = resp.data
          console.log('mutiplela', data)   
          if (data.ok === 0) {
            vm.$bus.fnClosePopup()
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo('更新完成')
          vm.getFormList()          
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
            vm.$bus.fnClosePopup()
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
        })
        // this.$bus.apiCall(Param, function (data, vm) {
        //   if (data.ok === 0) {
        //     vm.$bus.fnClosePopup()
        //     vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
        //     return
        //   }
        //   vm.$bus.fnClosePopup()
        //   vm.$bus.fnShowInfo('更新完成')
        //   vm.getFormList()
        // }, this)
      })
      
    },
    updateMerchantRemark() {
      let Param = {
        module:'merchant',
        method:'updatePaymentRequestForm',
        payment_request_form_id:this.operatePFData.payment_request_form_id,
        invoice_no:this.operatePFData.invoice_no,
        invoice_date:this.operatePFData.invoice_date,
        merchant_remark:this.operatePFData.merchant_remark
      }

      apiUpdatePaymentRequestForm(Param).then(function(resp){
        let data = resp.data
        vm.$bus.fnShowInfo('更新完成')
        vm.getFormList()
        vm.showOperateForm = false
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
          return
        }
      })

      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //     return
      //   }
      //   vm.$bus.fnShowInfo('更新完成')
      //   vm.getFormList()
      //   vm.showOperateForm = false
      // }, this)
    },
    cancelApplyForm() {
      let r = window.confirm('是否刪單？')
      if (r) {
        let Param = {
          module:'merchant',
          method:'cancelPaymentRequestForm',
          payment_request_form_id:this.operatePFData.payment_request_form_id,
          merchant_remark:this.operatePFData.merchant_remark,
        }
        apiCancelPaymentRequestForm(Param).then(function(resp){
          let data = resp.data
          vm.$bus.fnShowInfo('已取消此請款單申請')
          vm.getFormList()
          vm.showOperateForm = false
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
        })
        // this.$bus.apiCall(Param, function (data, vm) {
        //   if (data.ok === 0) {
        //     vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
        //     return
        //   }
        //   vm.$bus.fnShowInfo('已取消此請款單申請')
        //   vm.getFormList()
        //   vm.showOperateForm = false
        // }, this)
      }
    },
    // 供應商操作請款單明細,顯示一個modal然後根據該row的狀態決定popup上可以做的操作
    showFormDetail(item) {
      //要先用item.payment_request_form_id呼叫getPaymentRequestFormDetail才能拿到完整要顯示的資料
      let Param = {
        module:'merchant',
        method:'getPaymentRequestFormDetail',
        payment_request_form_id:item.payment_request_form_id,
      }
      let vm = this
      apiGetPaymentRequestFormDetail(Param).then(function(resp){
        let data = resp.data
        let groupCal = vm.ticketListToSummary(data.data.payment_request_details)
        vm.operatePFData = {
          payment_request_form_id:item.payment_request_form_id,
          pf:item.pf,
          invoice_no:item.invoice_no,
          invoice_date:item.invoice_date,
          merchant_remark:item.merchant_remark,
          sales_remark:item.sales_remark,
          total:item.request_amount,
          totalTax:Math.round(item.request_amount/1.05*0.05),
          //itemSummary:"服務費"+data.data.payment_request_details[0].ticket_project_id+(groupCal.group_count===1?'':'等'+groupCal.group_count+'個課程服務費收入'),
          itemSummary:"服務費",
          itemDetails:groupCal.itemDetails,
          originalStatus:item.form_status,
        }
        vm.$refs.operateForm.refreshModelVar()
        if (vm.$bus.getRole() === 'merchant' || vm.$bus.getRole() === 'spalogin') {
          if (item.status !== '申請中') {
            vm.$refs.operateForm.setDisabled('btn-merchant-update-remark')
            vm.$refs.operateForm.setDisabled('merchant_remark')
            vm.$refs.operateForm.setDisabled('btn-merchant-cancel-apply')
          }
          else {
            vm.$refs.operateForm.setDisabled('btn-merchant-update-remark',false)
            vm.$refs.operateForm.setDisabled('merchant_remark',false)
            vm.$refs.operateForm.setDisabled('btn-merchant-cancel-apply',false)
          }
        }
        else {
          switch (item.status) {
            case '申請中':
              vm.$refs.operateForm.setDisabled('sales_remark',false)
              vm.$refs.operateForm.setDisabled('btn-sales-update-remark',false)
              vm.$refs.operateForm.setDisabled('btn-reject-apply',false)
              vm.$refs.operateForm.setDisabled('btn-process-apply',false)
              vm.$refs.operateForm.setDisabled('btn-download-apply',true)
              vm.$refs.operateForm.setDisabled('btn-confirm-paid',true)
              break
            case '處理中':
              vm.$refs.operateForm.setDisabled('sales_remark',false)
              vm.$refs.operateForm.setDisabled('btn-sales-update-remark',false)
              vm.$refs.operateForm.setDisabled('btn-reject-apply',false)
              vm.$refs.operateForm.setDisabled('btn-process-apply',true)
              vm.$refs.operateForm.setDisabled('btn-download-apply',false)
              vm.$refs.operateForm.setDisabled('btn-confirm-paid',true)
              break
            case '已下載':
              vm.$refs.operateForm.setDisabled('sales_remark',false)
              vm.$refs.operateForm.setDisabled('btn-sales-update-remark',false)
              vm.$refs.operateForm.setDisabled('btn-reject-apply',false)
              vm.$refs.operateForm.setDisabled('btn-process-apply',true)
              vm.$refs.operateForm.setDisabled('btn-download-apply',true)
              vm.$refs.operateForm.setDisabled('btn-confirm-paid',false)
              break
            case '已放款':
            case '已取消':
            case '已拒絕':
              vm.$refs.operateForm.setDisabled('sales_remark',true)
              vm.$refs.operateForm.setDisabled('btn-sales-update-remark',true)
              vm.$refs.operateForm.setDisabled('btn-reject-apply',true)
              vm.$refs.operateForm.setDisabled('btn-process-apply',true)
              vm.$refs.operateForm.setDisabled('btn-download-apply',true)
              vm.$refs.operateForm.setDisabled('btn-confirm-paid',true)
              break
          }
        }
        vm.showOperateForm = true
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
          return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //     return
      //   }
      //   let groupCal = vm.ticketListToSummary(data.data.payment_request_details)
      //   vm.operatePFData = {
      //     payment_request_form_id:item.payment_request_form_id,
      //     pf:item.pf,
      //     invoice_no:item.invoice_no,
      //     invoice_date:item.invoice_date,
      //     merchant_remark:item.merchant_remark,
      //     sales_remark:item.sales_remark,
      //     total:item.request_amount,
      //     totalTax:Math.round(item.request_amount/1.05*0.05),
      //     //itemSummary:"服務費"+data.data.payment_request_details[0].ticket_project_id+(groupCal.group_count===1?'':'等'+groupCal.group_count+'個課程服務費收入'),
      //     itemSummary:"服務費",
      //     itemDetails:groupCal.itemDetails,
      //     originalStatus:item.form_status,
      //   }
      //   vm.$refs.operateForm.refreshModelVar()
      //   if (vm.$bus.getRole() === 'merchant' || vm.$bus.getRole() === 'spalogin') {
      //     if (item.status !== '申請中') {
      //       vm.$refs.operateForm.setDisabled('btn-merchant-update-remark')
      //       vm.$refs.operateForm.setDisabled('merchant_remark')
      //       vm.$refs.operateForm.setDisabled('btn-merchant-cancel-apply')
      //     }
      //     else {
      //       vm.$refs.operateForm.setDisabled('btn-merchant-update-remark',false)
      //       vm.$refs.operateForm.setDisabled('merchant_remark',false)
      //       vm.$refs.operateForm.setDisabled('btn-merchant-cancel-apply',false)
      //     }
      //   }
      //   else {
      //     switch (item.status) {
      //       case '申請中':
      //         vm.$refs.operateForm.setDisabled('sales_remark',false)
      //         vm.$refs.operateForm.setDisabled('btn-sales-update-remark',false)
      //         vm.$refs.operateForm.setDisabled('btn-reject-apply',false)
      //         vm.$refs.operateForm.setDisabled('btn-process-apply',false)
      //         vm.$refs.operateForm.setDisabled('btn-download-apply',true)
      //         vm.$refs.operateForm.setDisabled('btn-confirm-paid',true)
      //         break
      //       case '處理中':
      //         vm.$refs.operateForm.setDisabled('sales_remark',false)
      //         vm.$refs.operateForm.setDisabled('btn-sales-update-remark',false)
      //         vm.$refs.operateForm.setDisabled('btn-reject-apply',false)
      //         vm.$refs.operateForm.setDisabled('btn-process-apply',true)
      //         vm.$refs.operateForm.setDisabled('btn-download-apply',false)
      //         vm.$refs.operateForm.setDisabled('btn-confirm-paid',true)
      //         break
      //       case '已下載':
      //         vm.$refs.operateForm.setDisabled('sales_remark',false)
      //         vm.$refs.operateForm.setDisabled('btn-sales-update-remark',false)
      //         vm.$refs.operateForm.setDisabled('btn-reject-apply',false)
      //         vm.$refs.operateForm.setDisabled('btn-process-apply',true)
      //         vm.$refs.operateForm.setDisabled('btn-download-apply',true)
      //         vm.$refs.operateForm.setDisabled('btn-confirm-paid',false)
      //         break
      //       case '已放款':
      //       case '已取消':
      //       case '已拒絕':
      //         vm.$refs.operateForm.setDisabled('sales_remark',true)
      //         vm.$refs.operateForm.setDisabled('btn-sales-update-remark',true)
      //         vm.$refs.operateForm.setDisabled('btn-reject-apply',true)
      //         vm.$refs.operateForm.setDisabled('btn-process-apply',true)
      //         vm.$refs.operateForm.setDisabled('btn-download-apply',true)
      //         vm.$refs.operateForm.setDisabled('btn-confirm-paid',true)
      //         break
      //     }
      //   }
      //   vm.showOperateForm = true
      // }, this)
    },
    selectionChange(item) {
      //hover到的row點任何地方都選取,但已選取只能點checkbox uncheck(勾勾很小,方便選取)
      if (this.$bus.getRole() !== 'admin' && !item.checked) {
        item.checked = true
      }
    },
    clearCreatePaperForm(evt){
      // console.log(evt);
      // 放棄建立紙本請款單
      this.createPFData1 = {
        invoice_no:null,
        SelectedMerchantItem:null,
        itemSummary:"服務費",
        invoice_date:null,
        total:null,
        totalTax:null,
        inside_ids:'',
        form_summary:''
      };
      this.paper_merchant_id = null;
      this.paper_merchant_invoice_type = 'receipt';
      this.merchant_lists = [];
      // 清除另一個component的
      this.$refs.paperapplyform.initDefault();
      // eslint-disable-next-line
      console.log("清",this.$refs.paperapplyform.createPFData1_child.inside_ids);
      this.$refs.createForm1.refreshModelVar(); // 讓畫面跟data一致
      evt.preventDefault()
      return 
    },
    pressOkCreatePaperForm(evt){
      // eslint-disable-next-line
      console.log("ok",this.$refs.paperapplyform.createPFData1_child.inside_ids);
      // console.log(this.$bus.session.invoice_type);  應該回傳供應商使用發票或收據，但是目前不傳
      // console.log(evt)
      // 判斷有點亂
      if(this.createPFData1 && this.createPFData1.SelectedMerchantItem == undefined){
        this.$refs.createForm1.triggerAlert('供應商必填')
        this.$refs.createForm1.setFocus('SelectedMerchantItem')
        // doneCB()
        evt.preventDefault()
        return     
      }
      // 發票號碼 日期非必填，但填了另一個必填
      if(this.createPFData1.invoice_no || this.createPFData1.invoice_date){
        if (!this.createPFData1.invoice_no.trim()) {
          this.$refs.createForm1.triggerAlert('發票號碼必填')
          this.$refs.createForm1.setFocus('invoice_no')
          // doneCB()
          evt.preventDefault()
          return
        } 
        if(/^[a-zA-Z]{2}[0-9]{8}$/.test(this.createPFData1.invoice_no) === false){
          this.$refs.createForm1.triggerAlert('發票號碼格式錯誤(請檢查一下，應該要是前兩碼英文後八碼數字如AA12345678這樣的格式，且不要輸入到全形的英數字喔)')
          this.$refs.createForm1.setFocus('invoice_no')
          // doneCB()
          evt.preventDefault()
          return
        }
        if (!this.createPFData1.invoice_date) {
          this.$refs.createForm1.triggerAlert('發票日期必填')
          this.$refs.createForm1.setFocus('invoice_date')
          // doneCB()
          evt.preventDefault()
          return
        }       
      }
      if(!this.createPFData1.total){
        this.$refs.createForm1.triggerAlert('總金額必填')
        this.$refs.createForm1.setFocus('total')
        // doneCB()
        evt.preventDefault()
        return          
      }
      //有收據廠商沒有稅額,不需檢查值正確讓api後端檢查
      if(this.paper_merchant_invoice_type =='invoice' && !this.createPFData1.totalTax){
        this.$refs.createForm1.triggerAlert('稅額必填')
        this.$refs.createForm1.setFocus('totalTax')
        // doneCB()
        evt.preventDefault()
        return          
      }
      // 檢查所有掃描票券金額數量是否與keyin值相符
      if(this.createPFData1.total != this.$refs.paperapplyform.totalAmount){
        this.$refs.createForm1.triggerAlert('輸入總金額與掃描票券金額不符！')
        this.$refs.createForm1.setFocus('total')
        // doneCB()
        evt.preventDefault()
        return          
      }       
      if(this.paper_merchant_invoice_type =='invoice' && this.createPFData1.totalTax != Math.round((this.createPFData1.total)/1.05*0.05)){
        this.$refs.createForm1.triggerAlert('輸入稅額或總金額似乎有誤！請檢查')
        this.$refs.createForm1.setFocus('totalTax')
        // doneCB()
        evt.preventDefault()
        return        
      }
      // 服務費組成
      if(!this.$refs.paperapplyform.createPFData1_child.inside_ids){
        this.$refs.createForm1.triggerAlert('尚未輸入任何一張票')
        this.$refs.createForm1.setFocus('iTestInput')
        evt.preventDefault()
      }      
      this.createPFData1.inside_ids = this.$refs.paperapplyform.createPFData1_child.inside_ids;
      this.createPFData1.form_summary = this.$refs.paperapplyform.createPFData1_child.form_summary;

      let Param = {
        module:'admin_manage',
        method:'createPaperPaymentForm',
        invoice_no: this.createPFData1.invoice_no?this.createPFData1.invoice_no:'',
        invoice_date: this.createPFData1.invoice_date?this.createPFData1.invoice_date:'',
        total_amount: this.createPFData1.total,
        tax_amount: this.createPFData1.totalTax,
        ticket_item_ids: this.createPFData1.inside_ids, //this.createPFData1.inside_ids,
        form_summary: this.createPFData1.form_summary,
        merchant_id: this.paper_merchant_id,
      }
      let vm = this
      //然後呼叫api建立紙本 請款單
      apiCreatePaperPaymentForm(Param).then(function(resp){
        let data = resp.data
        vm.showCreateForm = false
        vm.$bus.fnShowInfo('申請成功,請款單號為:'+data.data.IdNo)
        vm.CurrentTabIndex = 1
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
          // doneCB()
          evt.preventDefault()
          return
        }
      })
      //然後呼叫api建立紙本 請款單
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //     // doneCB()
      //     evt.preventDefault()
      //     return
      //   }
      //   // eslint-disable-next-line
      //   setTimeout(() => {
      //     vm.showCreateForm = false
      //     vm.$bus.fnShowInfo('申請成功,請款單號為:'+data.data.IdNo)
      //     vm.CurrentTabIndex = 1
      //     // doneCB()
      //   }, 3000)
      // },this)
    },
    confirmCreateApply(doneCB, evt) {
      //檢查必填
      // console.log("->", this.createPFData);
      if (this.$bus.session.invoice_type === 'invoice') {
        if (this.createPFData.invoice_no.trim() === '') {
          this.$refs.createForm.triggerAlert('發票號碼必填')
          this.$refs.createForm.setFocus('invoice_no')
          doneCB()
          evt.preventDefault()
          return
        }
        // 1211 yukidebug 
        if(/^[a-zA-Z]{2}[0-9]{8}$/.test(this.createPFData.invoice_no) === false){
          this.$refs.createForm.triggerAlert('發票號碼格式錯誤(請檢查一下，應該要是前兩碼英文後八碼數字如AA12345678這樣的格式，且不要輸入到全形的英數字喔)')
          this.$refs.createForm.setFocus('invoice_no')
          doneCB()
          evt.preventDefault()
          return
        }
        // 1211 end
        if (!this.createPFData.invoice_date) {
          this.$refs.createForm.triggerAlert('發票日期必填')
          this.$refs.createForm.setFocus('invoice_date')
          doneCB()
          evt.preventDefault()
          return
        }
      }
      let Param = {
        module:'merchant',
        method:'createPaymentRequestForm',
        invoice_no:this.createPFData.invoice_no,
        invoice_date:this.createPFData.invoice_date,
        total_amount:this.createPFData.total,
        tax_amount:this.createPFData.totalTax,
        ticket_item_ids:this.createPFData.inside_ids,
        merchant_remark:this.createPFData.merchant_remark,
        form_summary:this.createPFData.form_summary
      }

      let vm = this
      Param.invoice_date = Param.invoice_date.replaceAll('/', '-')
      apiCreatePaymentRequestForm(Param).then(function(resp){
        console.log('finishe', resp)
        let data = resp.data
        vm.showCreateForm = false
        vm.$bus.fnShowInfo('申請成功,請款單號為:'+data.data.IdNo)
        vm.CurrentTabIndex = 1     
        doneCB()
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
          doneCB()
          evt.preventDefault()
          return
        }
      })

      //然後呼叫api建立請款單
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //     doneCB()
      //     evt.preventDefault()

      //     return
      //   }
      //   // eslint-disable-next-line
      //   setTimeout(() => {
      //     vm.showCreateForm = false
      //     vm.$bus.fnShowInfo('申請成功,請款單號為:'+data.data.IdNo)
      //     vm.CurrentTabIndex = 1
      //     doneCB()
      //   }, 3000)
      // },this)
    },
    createPapperApplyFrom(){
      // alert("手動建立紙本請款單囉！");
      this.showPaperCreateForm = true; 
    },  
    createApplyFrom() {
      //先檢查至少要有勾選一張票才可以建立請款單
      if (this.totalSelected === 0) {
        this.$bus.fnShowInfo('請先勾選要請款的票卷')
        return
      }
      //跑ticketList,逐PI分組,分別計算總數
      //group_prod key=product_id,每一個PI內的物件則有name,count,list id tickets
      /*let group_prod = {}
      let group_count = 0
      let ticket_item_ids = []
      let summary_str_arr = []
      for (let i=0;i<this.ticketList.length;i++) {
        if (!group_prod.hasOwnProperty(this.ticketList[i].product_id)) {
          group_count++
          group_prod[this.ticketList[i].product_id] = {
            product_id:this.ticketList[i].product_id,
            count:0,
            totalAmt:0,
            tickets:[],
            ticket_name:this.ticketList[i].ticket_project_name,
            course_id: '服務費'+this.ticketList[i].ticket_project_id,
            cost_price:this.ticketList[i].cost_price,
            _showDetails:false
          }
        }
        group_prod[this.ticketList[i].product_id].count++
        group_prod[this.ticketList[i].product_id].totalAmt += this.ticketList[i].cost_price
        group_prod[this.ticketList[i].product_id].tickets.push(this.ticketList[i])
        ticket_item_ids.push(this.ticketList[i].ticket_item_id)
      }
      let detail_arr = []
      let grandTotalAmt = 0
      for (let prod in group_prod) {
        detail_arr.push(group_prod[prod])
        grandTotalAmt += group_prod[prod].totalAmt
        summary_str_arr.push(group_prod[prod].course_id+'_'+group_prod[prod].count+'_'+group_prod[prod].cost_price+'_'+group_prod[prod].totalAmt)
      }
      this.createPFData.itemSummary = "服務費"+this.ticketList[0].ticket_project_id+(group_count===1?'':'等'+group_count+'個課程服務費收入')
      this.createPFData.total = grandTotalAmt
      this.createPFData.totalTax = Math.round(grandTotalAmt/1.05*0.05)
      this.createPFData.itemDetails = detail_arr
      //重新打開時清掉重填
      this.createPFData.invoice_no = ""
      //this.createPFData.invoice_date = (new Date()).toLocaleString().slice(0,10)
      this.createPFData.invoice_date = this.getDateByStr()
      this.createPFData.merchant_remark = ""
      this.createPFData.inside_ids = ticket_item_ids.join()
      this.createPFData.form_summary = summary_str_arr.join()
      */
      let groupCal = this.ticketListToSummary(this.ticketList, true)
      //this.createPFData.itemSummary = "服務費"+this.ticketList[0].ticket_project_id+(groupCal.group_count===1?'':'等'+groupCal.group_count+'個課程服務費收入')
      this.createPFData.itemSummary = "服務費"
      this.createPFData.total = groupCal.grandTotalAmt
      this.createPFData.totalTax = Math.round(groupCal.grandTotalAmt/1.05*0.05)
      this.createPFData.itemDetails = groupCal.itemDetails
      //重新打開時清掉重填
      this.createPFData.invoice_no = ""
      //this.createPFData.invoice_date = (new Date()).toLocaleString().slice(0,10)
      this.createPFData.invoice_date = (this.$bus.session.invoice_type === 'invoice' ? this.getDateByStr():'')
      this.createPFData.merchant_remark = ""
      this.createPFData.inside_ids = groupCal.inside_ids
      this.createPFData.form_summary = groupCal.form_summary
      this.$refs.createForm.refreshModelVar()
      this.showCreateForm = true
    },
    ticketListToSummary(ticketList, for_create = false) {
      let group_prod = {}
      let group_count = 0
      let ticket_item_ids = []
      let summary_str_arr = []
      for (let i=0;i<ticketList.length;i++) {
        if (for_create && !ticketList[i].checked) {
          continue
        }
        if (!group_prod.hasOwnProperty(ticketList[i].product_id)) {
          group_count++
          group_prod[ticketList[i].product_id] = {
            product_id:ticketList[i].product_id,
            count:0,
            totalAmt:0,
            tickets:[],
            ticket_name:ticketList[i].ticket_project_name,
            course_id: '服務費',//+ticketList[i].ticket_project_id,
            cost_price:ticketList[i].cost_price,
            _showDetails:false
          }
        }
        group_prod[ticketList[i].product_id].count++
        group_prod[ticketList[i].product_id].totalAmt += ticketList[i].cost_price
        group_prod[ticketList[i].product_id].tickets.push(ticketList[i])
        ticket_item_ids.push(ticketList[i].ticket_item_id)
      }
      let detail_arr = []
      let grandTotalAmt = 0
      for (let prod in group_prod) {
        detail_arr.push(group_prod[prod])
        grandTotalAmt += group_prod[prod].totalAmt
        summary_str_arr.push(group_prod[prod].course_id+'_'+group_prod[prod].count+'_'+group_prod[prod].cost_price+'_'+group_prod[prod].totalAmt)
      }
      return {
        group_prod:group_prod,
        group_count:group_count,
        inside_ids:ticket_item_ids.join(),
        itemDetails:detail_arr,
        form_summary:summary_str_arr.join(),
        grandTotalAmt:grandTotalAmt
      }
    },
    downloadCsv(item) {
      let Param = {
        module:'merchant',
        method:'getPFDetailCsv',
        pf:item.pf
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
          vm.loading = false
          return
        }
        //csv的content透過onlyContent為true拿到的字串由data.data回傳...最好另外回傳target_file_name,這樣可以替換my_data.csv
        let csvContent = "data:text/csv;charset=big-5," +data.data.csv
        let encodedUri = encodeURI(csvContent)
        let link = document.createElement("a")
        link.setAttribute("href", encodedUri)
        link.setAttribute("download", item.pf+".csv")
        document.body.appendChild(link) // Required for FF
        link.click()
      },this)
    },
    async downloadXls(item) {
      let Param = {
        module:'merchant',
        method:'getPFDetailXls',
        pf:item.pf
      }
      let vm = this
      let url = await apiGetPFDetailXls(Param).then(function(resp){
        vm.loading = false
        let data = resp.data
        console.log(data)
        return data.data.url

      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
          vm.loading = false
          return
        }
      })

      if (!url) {
        return
      }

      let download_url = ''
      download_url = url.replace('/api/ticket', '')

      apiDownloadFile(download_url).then(function(resp){
          const url = window.URL.createObjectURL(new Blob([resp.data], {type:'application/vnd.ms-excel'}));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', download_url.split('&name=')[1]);
          document.body.appendChild(link);
          link.click();
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
      })

      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
      //     vm.loading = false
      //     return
      //   }
      //   saveAs(vm.getBlobFromBase64(data.data.xlsx),data.data.file_name)
      // },this)
    },
    async downloadSelectedXls() {
      let form_ids = []
      for (let i=0;i<this.formList.length;i++) {
        if (this.formList[i].checked) {
          form_ids.push(this.formList[i].payment_request_form_id)
        }
      }
      if (form_ids.length === 0) {
        this.$bus.fnShowInfo('沒有勾選的表單')
        return
      }
      let Param = {
        module:'merchant',
        method:'getPFDetailXls3',
        form_ids:form_ids
      }
      let vm = this
      let url = await apiGetPFDetailXls3(Param).then(function(resp){
        let data = resp.data
        vm.loading = false

        // 如果是舊的php這行就會動
        if (data.data.url === undefined) {
          saveAs(vm.getBlobFromBase64(data.data.xlsx),data.data.file_name)
        }
        console.log(resp)
        return data.data.url
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
          vm.loading = false
          return
        }
      })

      if (!url) {
        return
      }

      let download_url = ''
      download_url = url.replace('/api/ticket', '')

      apiDownloadFile(download_url).then(function(resp){
          const url = window.URL.createObjectURL(new Blob([resp.data], {type:'application/vnd.ms-excel'}));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', download_url.split('&name=')[1]);
          document.body.appendChild(link);
          link.click();
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
      })
      
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
      //     vm.loading = false
      //     return
      //   }
      //   saveAs(vm.getBlobFromBase64(data.data.xlsx),data.data.file_name)
      // },this)
    },
    checkAllUpdate(checkAll) {
      for (let i=0;i<this.ticketList.length;i++ ) {
        if (this.ticketList[i].checked !== checkAll) {
          this.ticketList[i].checked = checkAll
        }
      }
    },
    updateCheckAll() {
      setTimeout(() => {
        if (this.totalSelected === 0) {
          this.checkAll = false
        }
        if (this.totalSelected > 0 && this.totalSelected === this.ticketList.length) {
          this.checkAll = true
        }
      }, 100);
    },
    checkAllUpdate2(checkAll) {
      for (let i=0;i<this.formList.length;i++ ) {
        if (this.formList[i].checked !== checkAll) {
          this.formList[i].checked = checkAll
        }
      }
    },
    updateCheckAll2() {
      setTimeout(() => {
        if (this.totalSelected2 === 0) {
          this.checkAll2 = false
        }
        if (this.totalSelected2 > 0 && this.totalSelected2 === this.formList.length) {
          this.checkAll2 = true
        }
      }, 100);
    },
    handleScroll(evt) {
      if (this.calScrollRatio(evt) > 0.95) {
        this.$refs.scrollarea.$emit('scrolldownend')
      }
    }, 
    changeTab(index) {
      this.tabClicking = true
      this.CurrentTabIndex = index
      let refresh_merchant = null
      if (this.filterData.SelectedMerchantItem && this.filterData.SelectedMerchantItem.merchant_id) {
        // default值要保留
        this.filterOptions[this.merchantOptionIndex].defaultValue = this.filterData.SelectedMerchantItem
        refresh_merchant = {'key':'SelectedMerchantItem','val':{'merchant_id':this.filterData.SelectedMerchantItem.merchant_id}}      
      }
      else {
        //回來tab1會重撈,其他tab切換時tab1的data要先清掉,否則選取中merchant清掉狀態回到tab1會有上次殘留的可勾選票券
        this.ticketList = []
        this.ticketTotal = 0
        this.filterOptions[this.merchantOptionIndex].defaultValue = null
      }

      //寫死的更新filterOptions後再initDefault即可更新filterForm狀態...
      if (index > 0) {
        this.filterOptions[this.storeOptionIndex].hide = true
        this.filterOptions[this.storeOptionIndex].placeholder = ""
        this.filterOptions[this.productOptionIndex].hide = true
        this.filterOptions[this.productOptionIndex].placeholder = ""
        // type不同dataOptions也不同= =
        switch (index) {
          case 1:
            this.filterOptions[this.formTypeOptionIndex].dataOptions = [{text:'全部請款中',value:''},{text:'申請中',value:'requesting'},{text:'處理中',value:'processing'},{text:'已下載',value:'downloaded'}]
            this.filterData.statusType = ''
            break
          case 2:
            this.filterOptions[this.formTypeOptionIndex].dataOptions = [{text:'全部已放款',value:''},{text:'已下載',value:'paid-downloaded'},{text:'未下載(零成本)',value:'paid-not-downloaded'}]
            this.filterData.statusType = ''
            break
          case 3:
            this.filterOptions[this.formTypeOptionIndex].dataOptions = [{text:'全部刪單/退審',value:''}]
            this.filterData.statusType = ''
            break
        }
        this.filterOptions[this.formTypeOptionIndex].hide = false
        this.filterOptions[this.formTypeOptionIndex].placeholder = "篩選狀態"
        this.filterOptions[this.createFromOptionIndex].hide = false
        this.filterOptions[this.createFromOptionIndex].placeholder = "篩選請款日起"
        this.filterOptions[this.createToOptionIndex].hide = false
        this.filterOptions[this.createToOptionIndex].placeholder = "篩選請款日迄"
        //供應商請款單數量不會那麼多,不做預設只撈最近3個月的預設值(我們的請款中已放款一年沒更新了,所以不可以改= =)
        if (this.$bus.getRole()==='admin' && !this.filterData.createFromDate) {
          this.filterData.createFromDate = this.getDateByStr('', -90)
          this.filterOptions[this.createFromOptionIndex].placeholder = "篩選請款日起"
        }
        // 有bug未解,後面切換時default value切換預設選取會失效=>要再想辦法解決
        setTimeout(() => {
          this.$refs.filterForm.refreshModelVar('statusType,createFromDate')            
        }, 50);
      }
      else {
        this.checkAll = false
        // 店家自行請款時不用篩選分店,乖乖對自店核銷電子票請款就好
        this.filterOptions[this.storeOptionIndex].hide = (this.$bus.getRole() !== 'admin' && !this.$bus.session.is_super_manage)
        this.filterOptions[this.storeOptionIndex].placeholder = "全部分店"
        this.filterData.selectedStore = null
        this.filterOptions[this.productOptionIndex].hide = false
        this.filterOptions[this.productOptionIndex].placeholder = "全部課程"
        // admin才要清
        if (this.$bus.getRole() !== 'merchant' && this.$bus.getRole() !== 'spalogin') {
          this.filterData.SelectedMerchantItem = null
        }
        this.filterOptions[this.formTypeOptionIndex].hide = true
        this.filterOptions[this.formTypeOptionIndex].placeholder = ""
        this.filterOptions[this.createFromOptionIndex].hide = true
        this.filterOptions[this.createFromOptionIndex].placeholder = ""
        this.filterOptions[this.createToOptionIndex].hide = true
        this.filterOptions[this.createToOptionIndex].placeholder = ""
      }
      // this.$refs.filterForm.initDefault()
      // 第一個分頁切換回來時若有選定merchant,則要reload那個merchant的資料(分店課程選擇被清掉)
      if (index == 0) {
        this.ticketList = []
        if (refresh_merchant) {
          setTimeout(() => {
            this.storeServiceChanged(refresh_merchant)
          }, 200);
        }
      }
      else {
        this.getFormList()
      }
    },
    storeServiceChanged_1(upd){
      // console.log("upd",upd.val);
      // 回傳merchant_id 讓 paperApplyForm component 自己去抓 parentVue
      if(upd.key === 'SelectedMerchantItem'){
        if (upd.val && upd.val.merchant_id) {
          this.paper_merchant_id = upd.val.merchant_id;
          this.paper_merchant_invoice_type = upd.val.invoice_type;
          this.$refs.createForm1.setDisabled('totalTax', this.paper_merchant_invoice_type == 'receipt');
          this.$refs.createForm1.setDisabled('invoice_no', this.paper_merchant_invoice_type == 'receipt');
          this.$refs.createForm1.setDisabled('invoice_date', this.paper_merchant_invoice_type == 'receipt');
          //切成收據時清掉輸入中的發票號碼
          if (this.paper_merchant_invoice_type == 'receipt') {
            this.createPFData1.invoice_no = '';
            this.createPFData1.invoice_date = '';
            this.createPFData1.totalTax = '';
            this.$refs.createForm1.refreshModelVar('invoice_no,invoice_date,totalTax');
          }
          // console.log(this.paper_merchant_id);
        }
      }
    },
    storeServiceChanged(upd) {
      if (upd.key === 'SelectedMerchantItem') {
        if (upd.val && upd.val.merchant_id) {
          this.SelectedMerchantId = upd.val.merchant_id
          this.loadMerchantById(upd.val.merchant_id)
        }
        else {
          this.storeList = []
          this.TicketServiceList = []
          this.filterData.SelectedMerchantItem = null
          this.filterData.selectedStore = null
          this.filterData.selectedServiceItem = null
        }
      }
      else if (['selectedStore','selectedServiceItem'].includes(upd.key)) {
        //this.storeList = []
        //this.TicketServiceList = []
        //this.filterData.SelectedMerchantItem = null
        //this.SelectedMerchantId = 0
        //沒選取商家時不撈待請款票卷,之前殘餘的也要清除
        this.ticketList = []
        this.ticketTotal = 0
        //即使是這樣也會再觸發選項變更事件,所以下面要再判斷有merchant_id才抓資料
        //this.filterData.selectedStore = null
        //this.filterData.selectedServiceItem = null
      }
      else {
        // 只是改了表單的篩選條件,反正getFormList讀取綁定的屬性就好

      }
      // 後台總管理可跨供應商不必先選供應商,商家總管理必然釘死自己的商家id,所以只要把抓待核銷票卷時排掉沒有選擇商家的情境就夠了
      setTimeout(() => {
        // 看tab停在哪決定顯示哪一塊(後面三個tab共用同一個formList,但第一個是不一樣的ticket_list)
        if (this.CurrentTabIndex > 0) {
          if (!this.tabClicking) {
            this.formList = []
            this.getFormList()
          }
        }
        else {
          if (this.SelectedMerchantId) {
            this.ticketList = []
            this.getTicketList()
          }
        }
      }, 100);
    },

    getFormList(vm) {
      if (vm === undefined) {
        vm = this
      }
      // 必要條件只有商家id,分店與課程沒選預設該商家全部
      if (!vm.filterData.SelectedMerchantItem || !vm.filterData.SelectedMerchantItem.merchant_id) {
      //  return
      }
      
      let Param = {
        'module':'merchant',
        'method':'getPaymentRequestFormList',
        'merchant_id':vm.filterData.SelectedMerchantItem?vm.filterData.SelectedMerchantItem.merchant_id:0,
        'status':vm.filterData.statusType,
        'create_from':vm.filterData.createFromDate?vm.filterData.createFromDate:'',
        'create_to':vm.filterData.createToDate?vm.filterData.createToDate:'',
        'tab':this.currentTabKey
      }

      if (Param.create_from) {
        Param.create_from = Param.create_from.replaceAll('/','-')
      }
      if (Param.create_to) {
        Param.create_to = Param.create_to.replaceAll('/', '-')
      }

      apiGetPaymentRequestFormList(Param).then(function(resp){
        let data = resp.data
        // eslint-disable-next-line
        vm.formList = vm.parseRequestForms(data.data.payment_request_forms)
        setTimeout(() => {
          vm.tabClicking = false
        }, 300);
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      vm.tabClicking = false
    
      // vm.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     vm.formList = vm.parseRequestForms(data.data.payment_request_forms)
      //     setTimeout(() => {
      //       vm.tabClicking = false
      //     }, 300);
      // },vm)
    },
    parseRequestForms(src_forms) {
      let forms = this.CpObj(src_forms)
      const str_map = {
        'requesting':'申請中',
        'processing':'處理中',
        'downloaded':'已下載',
        'paid':'已放款',
        'cancelled':'已取消',
        'rejected':'已拒絕',
      }
      for (let i=0;i<forms.length;i++) {
        forms[i].form_status = forms[i].status
        forms[i].status = str_map[forms[i].status]
        if (forms[i].pf === undefined) {
          forms[i].pf = forms[i].PF
        }
        
      }
      return forms
    },
    getTicketList(append = false) {
      if (append === true) {
        if (!this.hasMore || this.isLoading) {
          return
        }
        this.ticketPageNumber ++
      }
      else {
        this.ticketPageNumber = 1
        this.hasMore = true
        this.$refs.wrapper.scrollTop = 0
      }
      let vm = this
      if (!vm.filterData.SelectedMerchantItem) {
        return
      }
      let Param = {
        'module':'merchant',
        'method':'getUsedWaitProcessTickets',
        'merchant_id':vm.filterData.SelectedMerchantItem.merchant_id,
        'merchant_store_id':vm.filterData.selectedStore?vm.filterData.selectedStore.merchant_store_id:0,
        'ticket_project_id': vm.filterData.selectedServiceItem?vm.filterData.selectedServiceItem.ticket_project_id:0,
        'page_number':this.ticketPageNumber,
        'items_per_page':this.ticketItemsPerPage,
      }
      this.isLoading = true
      apiGetUsedWaitProcessTickets(Param).then(function(resp){
        let data = resp.data
        // eslint-disable-next-line
        vm.ticketList = data.data.used_wait_process_ticket_list_view
        vm.ticketTotal = data.data.total_used_wait_process_tickets
        if (data.data.total_used_wait_process_tickets <= vm.ticketList.length) {
          vm.hasMore = false
        }
        vm.isLoading = false
        setTimeout(() => {
          vm.tabClicking = false
        }, 300);
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })
      this.isLoading = false
      this.tabClicking = false

      // vm.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     vm.ticketList = data.data.used_wait_process_ticket_list_view
      //     vm.ticketTotal = data.data.total_used_wait_process_tickets
      //     if (data.data.total_used_wait_process_tickets <= vm.ticketList.length) {
      //       vm.hasMore = false
      //     }
      //     vm.isLoading = false
      //     setTimeout(() => {
      //       vm.tabClicking = false
      //     }, 300);
      // },vm)
    },
    loadMerchantByKeyword (keyword) {
      if (!keyword) {
        // 有填至少一個關鍵字才回傳選項
        this.Merchants = []
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'getMerchantAutoComplete',
        'keyword':keyword,
      }
      let vm = this
      apiGetMerchantAutoComplete(Param).then(function(resp){
        let data = resp.data
        vm.Merchants = data.data.matched_merchant_list
        // props data 比對供應商找出merchant_id
        vm.merchant_lists = data.data.matched_merchant_list
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
        }
      })

      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     vm.Merchants = data.data.matched_merchant_list
      //     // props data 比對供應商找出merchant_id
      //     vm.merchant_lists = data.data.matched_merchant_list
      // },this)
    },
    loadMerchantById(merchant_id) {
      // 回到預設(event也應清掉,都換檢視供應商了)
      this.eventList = []
      this.storeList = []
      this.TicketServiceList = []
      if (!merchant_id) {
        this.filterData.SelectedMerchantItem = null
        this.filterData.selectedStore = null
        this.filterData.selectedServiceItem = null
        return
      }
      // 先判斷cache
      if (this.CachedMerchant.hasOwnProperty('m_'+merchant_id)) {
        this.storeList = this.CachedMerchant['m_'+merchant_id].merchant_stores
        this.TicketServiceList = this.CachedMerchant['m_'+merchant_id].merchant_ticket_projects
        return
      }
      else {
        this.FocusedMerchantId = merchant_id
        // 再抓資料庫放cache
        let Param = {
          'module':'admin_manage',
          'method':'get_merchant_by_id',
          'merchant_id':merchant_id,
        }
        apiGetMerchantById(Param).then(function(resp){
          let data = resp.data
          // eslint-disable-next-line
          data.data.merchant_stores = vm.parseAdminStores(data.data.merchant_stores)
          vm.storeList = data.data.merchant_stores
          let services = []
          for (let i=0;i<data.data.merchant_ticket_projects.length;i++) {
            let item = {
                ticket_project_service_item_id:data.data.merchant_ticket_projects[i].ticket_services[0].ticket_project_service_item_id,
                ticket_project_id:data.data.merchant_ticket_projects[i].id,
                merchant_service_id:data.data.merchant_ticket_projects[i].ticket_services[0].merchant_service_id,
                service_name:data.data.merchant_ticket_projects[i].ticket_services[0].service_name,
                product_id:data.data.merchant_ticket_projects[i].product_id
            }
            services.push(item)
          }
          data.data.merchant_ticket_projects = services
          vm.TicketServiceList = services
          vm.CachedMerchant['m_'+vm.FocusedMerchantId] = data.data
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
        })
        // this.$bus.apiCall(Param, function (data, vm) {
        //   if (data.ok === 0) {
        //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
        //     return
        //   }
        //   // eslint-disable-next-line
        //   data.data.merchant_stores = vm.parseAdminStores(data.data.merchant_stores)
        //   vm.storeList = data.data.merchant_stores
        //   let services = []
        //   for (let i=0;i<data.data.merchant_ticket_projects.length;i++) {
        //     let item = {
        //         ticket_project_service_item_id:data.data.merchant_ticket_projects[i].ticket_services[0].ticket_project_service_item_id,
        //         ticket_project_id:data.data.merchant_ticket_projects[i].id,
        //         merchant_service_id:data.data.merchant_ticket_projects[i].ticket_services[0].merchant_service_id,
        //         service_name:data.data.merchant_ticket_projects[i].ticket_services[0].service_name,
        //         product_id:data.data.merchant_ticket_projects[i].product_id
        //     }
        //     services.push(item)
        //   }
        //   data.data.merchant_ticket_projects = services
        //   vm.TicketServiceList = services
        //   vm.CachedMerchant['m_'+vm.FocusedMerchantId] = data.data
        // },this)
      }
    },
    parseAdminStores(stores) {
      let parsed_stores = []
      for (let i=0;i<stores.length;i++) {
        let store = stores[i]
        store.merchant_store_id = store.id
        delete store['id']
        parsed_stores.push(store)
      }
      return parsed_stores
    },
    showTicketUseStatus () {
      if (!this.filterData.ticket_no || this.filterData.ticket_no.trim().length !== 10) {
        this.$bus.fnShowInfo('請輸入完整AA票號')
      }
      let Param = {
        'module':'merchant',
        'method':'getTicketStatus',
        'ticket_no':this.filterData.ticket_no,
      }
      let vm = this
      apiGetTicketStatus(Param).then(function(resp){
        let data = resp.data
          // eslint-disable-next-line
          let usages = data.data.usages
          let informMsg = usages[0].ticket_project_name+'('+usages[0].buyer+'於'+usages[0].print_time+'購買）'
          if (usages.length > 1) {
            informMsg += '<br>此票卷可使用次數為'+usages.length+'<br>'
          }
          for (let i=0;i<usages.length;i++) {
            if (usages[i].ticket_scan_time) {
              informMsg += '已於'+usages[i].ticket_scan_time+'在'+usages[i].service_store+'使用<br/>'
            }
            else if (usages[i].reserve_time) {
              informMsg += '已於'+usages[i].reserve_time+'在'+usages[i].reserve_store+'預約'+usages[i].reserve_start+'開始的時段(尚未到店使用)<br/>'
            }
            else {
              informMsg += '尚未預約使用<br>'
            }
          }
          vm.$bus.fnShowInfo(informMsg)
          return
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('查看失敗:'+data.msg)
            return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('查看失敗:'+data.msg)
      //       return
      //     }
      //     // eslint-disable-next-line
      //     let usages = data.data.usages
      //     let informMsg = usages[0].ticket_project_name+'('+usages[0].buyer+'於'+usages[0].print_time+'購買）'
      //     if (usages.length > 1) {
      //       informMsg += '<br>此票卷可使用次數為'+usages.length+'<br>'
      //     }
      //     for (let i=0;i<usages.length;i++) {
      //       if (usages[i].ticket_scan_time) {
      //         informMsg += '已於'+usages[i].ticket_scan_time+'在'+usages[i].service_store+'使用<br/>'
      //       }
      //       else if (usages[i].reserve_time) {
      //         informMsg += '已於'+usages[i].reserve_time+'在'+usages[i].reserve_store+'預約'+usages[i].reserve_start+'開始的時段(尚未到店使用)<br/>'
      //       }
      //       else {
      //         informMsg += '尚未預約使用<br>'
      //       }
      //     }
      //     vm.$bus.fnShowInfo(informMsg)
      //     return
      // },this)
    }
  },
  computed: {
    totalSelected: {
      cache: false,
      get () {
        //計算當前已選取的數量
        let selected = 0
        for (let i=0;i<this.ticketList.length;i++) {
          if (this.ticketList[i].checked) {
            selected++
          }
        }
        return selected
      }
    },
    totalSelected2: {
      cache: false,
      get () {
        //計算當前已選取的數量
        let selected = 0
        for (let i=0;i<this.formList.length;i++) {
          if (this.formList[i].checked) {
            selected++
          }
        }
        return selected
      }
    },
    currentTabKey: {
      cache: false,
      get () {
        // 翻譯index為字串而已
        if (this.CurrentTabIndex === 1) {
          return 'requesting'
        }
        else if (this.CurrentTabIndex === 2) {
          return 'paid'
        }
        else if (this.CurrentTabIndex === 3) {
          return 'failed'
        }
        else {
          return '' 
        }
      }
    },
  },
  created: function () {
    // 用戶使用時,預讀取票卷列表
    if (!this.$bus.session) {
      // 要重登入
      this.$bus.session = undefined
    }
    if (this.$bus.getRole() === 'admin') {
      this.applyFormFields.unshift({key:'apply_name',label:'請款者'})
      this.applyFormFields.unshift({key:'check',label:'選取'})
    }
    // 根據akey判斷更新storeOptionIndex與productOptionIndex
    // (不維護這個index也行,寫死這兩個index或是tab變更時每次都跑迴圈判斷akey來決定要update動態顯示隱藏的option)
    for (let i=0;i<this.filterOptions.length;i++) {
      if (this.filterOptions[i].akey === 'selectedStore') {
        this.storeOptionIndex = i
      }
      else if (this.filterOptions[i].akey === 'selectedServiceItem') {
        this.productOptionIndex = i
      }
      else if (this.filterOptions[i].akey === 'createDateFrom') {
        this.createFromOptionIndex = i
      }
    }
  },
  mounted () {
    //this.$refs.filterForm.initDefault()
    // 如已登入則放入Merchants與SelectedMerchantItem
    if (this.$bus.session && this.$bus.session != 'undefined' && (this.$bus.getRole() === 'merchant' || this.$bus.getRole() === 'spalogin') ) {
      let myMerchant = {
        'merchant_id': this.$bus.session.merchant_id,
        'merchant_name': this.$bus.session.merchant_name,
      }
      this.Merchants.push(myMerchant)
      this.filterData.SelectedMerchantItem = myMerchant
      this.SelectedMerchantId = this.$bus.session.merchant_id
      this.storeList = this.CpObj(this.$bus.session.stores)
      if (this.storeList.length > 1) {
        //this.storeList.unshift({'store_name':'全部分店','merchant_store_id':0})
      }
      //這個會觸發選項變更而抓api資料...造成瞬間抓兩次,下面那也兩次共四次
      //this.filterData.selectedStore = this.storeList[0]
      let service_items = []
      for (let i=0;i<this.$bus.session.ticket_projects.length;i++) {
        service_items.push({
          'merchant_service_id': this.$bus.session.ticket_projects[i].service_items[0].merchant_service_id,
          'service_name':this.$bus.session.ticket_projects[i].service_items[0].service_name,
          'ticket_project_id':this.$bus.session.ticket_projects[i].ticket_project_id,
        })
      }
      this.TicketServiceList = service_items
      if (this.TicketServiceList.length > 1) {
        //this.TicketServiceList.unshift({'service_name':'全部課程','merchant_service_id':0})
      }
      //this.filterData.selectedServiceItem = this.TicketServiceList[0]
    }
    else {
      /*let Param = {
        'module':'admin_manage',
        'method':'get_merchant_list',
        'merchant_name':'',
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          vm.Merchants = data.data
      },this)*/
    }
    
    //this.$refs.createForm.initDefault()
    this.$refs.operateForm.initDefault()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fc-day-grid {
  display:none;
}

.select-tickets {
  height: 50vh;
  width: 97vw;
  margin-left: auto;
  margin-right: auto;
  overflow-y:scroll;
  border-style: groove;
}

.view-forms {
  height: 62vh;
  width: 97vw;
  margin-left: auto;
  margin-right: auto;
  overflow-y:scroll;
  border-style: groove;
}

.detail-summary {
  height: 30vh;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  overflow-y:scroll;
}

.readonly-input {
  text-align:center;
}

</style>
<style>
/* set this for mobile view became too short to use */
.fc-time-grid-container {
  min-height:45vh;
  max-height:65vh;
}
</style>
